<template>
  <div>
    <label
      for="security-question"
      :class="labelClasses"
      v-text="label"
    />
    <div :class="containerClasses">
      <select
        id="security-question"
        v-model="local"
        name="security-question"
        class="pr-8"
        :class="{ 'error': !!errorMessage }"
      >
        <option
          v-for="(question, index) in questions"
          :key="`question-${index}`"
          :value="question"
          v-text="question"
        />
      </select>
    </div>
    <span
      v-if="!!errorMessage"
      class="help-block mb-1"
      v-text="errorMessage"
    />
  </div>
</template>

<script type="text/babel">
export default {
  name: 'SecurityQuestionField',
  props: {
    label: {
      type: String,
      required: false,
      default: 'Select a Security Question',
    },
    labelClasses: {
      type: String,
      required: false,
      default: '',
    },
    containerClasses: {
      type: String,
      required: false,
      default: 'select-container mb-4',
    },
    questions: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    local: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
